export enum DistributionSourceType {
    lists,
    searches,
    openAI,
    portfolios,
    mailingLists
}
